import { WebHaptics } from 'web-haptics';

const haptics = new WebHaptics();

export default haptics;
